import { render, staticRenderFns } from "./AssetNoteIcon.vue?vue&type=template&id=36426b58&"
import script from "./AssetNoteIcon.vue?vue&type=script&lang=js&"
export * from "./AssetNoteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports